import idb from "../idb";

export default {

	async doHousekeeping(maxCacheAgeHours) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["general"], "readwrite");
			trans.oncomplete = () => {
				resolve(apirequests);
			};

			const store = trans.objectStore("general");
			let apirequests = [];

			store.openCursor().onsuccess = (e) => {
				const cursor = e.target.result;
				if (cursor) {
					const minAgeMs =
						Date.now() - 1000 /* seconds */ * 60 /* minutes */ * 60 /* hours */ * maxCacheAgeHours;
					// console.log(cursor.value.timestamp, minAgeMs)
					if (cursor.value.timestamp < minAgeMs) {
						// console.log('delete!');
						cursor.delete();
					}
					cursor.continue();
				}
			};
		});
	},

	async getValue(id) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["general"], "readonly");
			const store = trans.objectStore("general");
			const request = store.get(id);

			request.onsuccess = (e) => {
				if(e.target.result) {
					resolve(e.target.result.value);
				}
			};
		});
	},

	async updateValue(id, value) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["general"], "readwrite");
			trans.oncomplete = () => {
				resolve();
			};
			const store = trans.objectStore("general");
			store.put({
				id: id ,
				value: value
			});
		});
	},

	async deleteValue(id) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["general"], "readwrite");
			trans.oncomplete = () => {
				resolve();
			};

			const store = trans.objectStore("general");
			store.delete(id);
		});
	}

};
